import { Access, BundleAccess } from '@prisma/client';
import { Layout, Space, Switch, Table, theme } from 'antd';

import { FeatureFlags } from '@app/web-components';

import { usePatchBundleAccess } from '../data';
import { useBundleViewPanel, useEligibilityColumn } from '../panels';

export type DetailTabProps = {
  bundleId: number;
};

export const DetailTab = ({ bundleId }: DetailTabProps) => {
  const { token } = theme.useToken();
  const { getAccessTableProps, getPanelSpaceProps } = useBundleViewPanel(bundleId, true);
  const { addColumn } = useEligibilityColumn(bundleId);
  const mutateBundleAccess = usePatchBundleAccess(bundleId);
  const { isFeatureEnabled } = FeatureFlags.useFeatureFlags();

  const { columns: accessColumns, ...accessTableProps } = getAccessTableProps();
  addColumn(accessColumns);

  if (isFeatureEnabled('eager_anchor')) {
    accessColumns?.unshift({
      dataIndex: 'isEagerAnchor',
      title: 'Anchor',
      render: (value: boolean, record: BundleAccess & { access: Access }) => (
        <Switch
          value={value}
          onChange={(isEagerAnchor) => mutateBundleAccess.mutate({ accessId: record.accessId, isEagerAnchor })}
        />
      ),
    });
  }

  return (
    <Layout
      style={{ margin: 'auto', width: '100%', maxWidth: 1200, paddingTop: 24, background: token.colorBgContainer }}
    >
      <Space
        {...getPanelSpaceProps({
          children: <Table {...accessTableProps} columns={accessColumns} />,
        })}
      />
    </Layout>
  );
};
